import React from 'react';

import Router from 'next/router';

import CustomError from '../components/Template/CustomError/CustomError';

import { Button } from '@lifepal/lifepal-design-system';

function Error({ statusCode }) {
  return (
    <CustomError>
      <p className="heading-xl-b title">
        Yah, Terjadi kesalahan pada sistem, silahkan coba beberapa saat lagi
      </p>
      <Button
        variant="primary"
        size="lg"
        isBlock
        onClick={() => Router.push('/media')}
        className="mt-3"
      >
        Kembali Ke Homepage
      </Button>
    </CustomError>
  );
}

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
